<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取人员信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			person_info接口提供了获取注册人员信息的功能
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/person_info">https://skfrm.cn/APIV2/person_info</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-value :propsTableData='frmReturnvalue'></frm-Return-value>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"groups":
		[
			{
				"group_name":"公共人员底库",
				"group_id":"4674"
			}
		],
		"data":
			{
				"name":"1",
				"gender":"2",
				"birth":"1989-12-28",
				"details":"1"
			},
		"image_url":
		[
			{
				"image_id":"448008",
				"url":"http://skfrm.cn/Uploads/image/2018-12-28/original1545983856139.jpg"
			}
		]
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnvalueTable';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','人员管理','获取人员信息'],				
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
					{"require":"是","name":"person_id","type":"int","msg":"人员id"},
				],
				frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
					{
						"Parameter":"data",
						"name":"array","msg":`人员详细信息数组 
							name    string     姓名
							gender     string     性别  1 女  2 男
							birth     string           生日
							details     string           备注
							show_image   string       展示图url`
					},
					{
						"Parameter":"image_url",
						"name":"array",
						"msg":`当前人员注册人脸图片url数组
						url     string   人脸图片url  
						image_id     string  人脸图片id`
					},
					{"Parameter":"groups","name":"array","msg":`当前人员所在人员组信息
					group_name     string      人员组名
					group_id        string     人员组id`},],
				frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"6008","errormessage":"person_id无效","msg":"人员不存在"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
	
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
	.el-table .el-table__row:nth-child(3)  .cell {
        white-space: pre-line!important;
    }
	.el-table .el-table__row:nth-child(4)  .cell {
        white-space: pre-line!important;
    }
	.el-table .el-table__row:nth-child(5)  .cell {
        white-space: pre-line!important;
    }
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Personnelmanagement/Accesstopersonnelinformation.vue